import dynamic from 'next/dynamic';

export default {
  // Navigation
  BreadCrumbs: dynamic(() => import('@eneco/sitecore-components-content/Breadcrumbs/Breadcrumbs')),
  FooterMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/FooterMenu')),
  Footer: dynamic(() => import('@eneco/sitecore-components-content/Footer/Footer')),
  LanguageSelector: dynamic(() => import('@eneco/sitecore-components-content/LanguageSelector/LanguageSelector')),
  Logo: dynamic(() => import('@eneco/sitecore-components-woonenergie/ImageLink/ImageLink')),
  MainNavigation: dynamic(() => import('@apps/header-shared-multilabel/Header')),
  MegaMenu: dynamic(() => import('@eneco/sitecore-components-content/MegaMenu/MegaMenu')),
  MegaMenuV2: dynamic(() => import('@eneco/sitecore-components-content/MegaMenuV2/MegaMenuV2')),
  MegaMenuDivision: dynamic(() => import('@eneco/sitecore-components-content/MegaMenuDivision/MegaMenuDivision')),
  MessageBar: dynamic(() => import('@eneco/sitecore-components-content/MessageBar/MessageBar')),
  NotificationsBar: dynamic(() => import('@eneco/sitecore-components-content/NotificationsBar/NotificationsBar')),
  SocialMediaMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/SocialMediaMenu')),
  SubFooterMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/SubFooterMenu')),

  // Content components
  PromoBox: dynamic(() => import('@eneco/sitecore-components-content/PromoBox/PromoBox')),
  Accordion: dynamic(() => import('@eneco/sitecore-components-content/Accordion/Accordion')),
  ContentCategories: dynamic(() => import('@eneco/sitecore-components-content/ContentCategories/ContentCategories')),
  ContactCustomerService: dynamic(
    () => import('@eneco/sitecore-components-content/ContactCustomerService/ContactCustomerService'),
  ),
  Hero: dynamic(() => import('@eneco/sitecore-components-content/Hero/Hero')),
  HeroCard: dynamic(() => import('@eneco/sitecore-components-content/HeroCard/HeroCard')),
  IconList: dynamic(() => import('@eneco/sitecore-components-content/IconList/IconList')),
  Image: dynamic(() => import('@eneco/sitecore-components-content/Image/Image')),
  LinkCard: dynamic(() => import('@eneco/sitecore-components-content/LinkCard/LinkCard')),
  List: dynamic(() => import('@eneco/sitecore-components-content/List/List')),
  NotificationBox: dynamic(() => import('@eneco/sitecore-components-content/NotificationBox/NotificationBox')),
  Price: dynamic(() => import('@eneco/sitecore-components-content/Price/Price')),
  SimpleTable: dynamic(() => import('@eneco/sitecore-components-content/SimpleTable/SimpleTable')),
  StoreButtons: dynamic(() => import('@eneco/sitecore-components-content/StoreButtons/StoreButtons')),
  TextStreamer: dynamic(() => import('@eneco/sitecore-components-content/TextStreamer/TextStreamer')),
  TopTaskCTA: dynamic(() => import('@eneco/sitecore-components-content/TopTaskCTA/TopTaskCTA')),
  TopTasks: dynamic(() => import('@eneco/sitecore-components-content/TopTasks/TopTasks')),
  UsabillaFeedback: dynamic(() => import('@eneco/sitecore-components-system/UsabillaFeedback/UsabillaFeedback')),
  AddressFinder: dynamic(() => import('@eneco/sitecore-components-content/AddressFinder/AddressFinder')),
  AffiliateCalculationTool: dynamic(() => import('@apps/flows-nl-eneco-energyFlow/CalculationTool')),
  StepExplainer: dynamic(
    () => import('@eneco/sitecore-components-content/StepExplainerVertical/StepExplainerVertical'),
  ),
  ShareOnSocials: dynamic(() => import('@eneco/sitecore-components-content/ShareOnSocials/ShareOnSocials')),
  ButtonLink: dynamic(() => import('@eneco/sitecore-components-content/ButtonLink/ButtonLink')),
  ButtonLineUp: dynamic(() => import('@eneco/sitecore-components-content/ButtonLineUp/ButtonLineUp')),

  // Other
  CookieWall: dynamic(() => import('@apps/cookiewall-nl-multilabel/CookieWall')),
  CustomerReview: dynamic(() => import('@apps/customerreview-shared-multilabel/CustomerReview')),
  ErrorPage: dynamic(() => import('@eneco/sitecore-components-content/ErrorPage/ErrorPage')),
  GTM: dynamic(() => import('@apps/gtm-shared-multilabel')),
  MetaData: dynamic(() => import('@eneco/sitecore-components-system/MetaData/MetaData')),
  MetaTags: dynamic(() => import('@eneco/sitecore-components-system/MetaTags/MetaTags')),
  StructuredDataSchema: dynamic(
    () => import('@eneco/sitecore-components-system/StructuredDataSchema/StructuredDataSchema'),
  ),
  Unsubscribe: dynamic(() => import('@apps/unsubscribe-shared-multilabel/Unsubscribe')),

  // Wrapper components
  Article: dynamic(() => import('@eneco/sitecore-components-content/Article/Article')),
  Carousel: dynamic(() => import('@eneco/sitecore-components-content/Carousel/Carousel')),
  Centered: dynamic(() => import('@eneco/sitecore-components-content/Centered/Centered')),
  LineUp: dynamic(() => import('@eneco/sitecore-components-content/LineUp/LineUp')),
  NavigationView: dynamic(() => import('@eneco/sitecore-components-content/NavigationView/NavigationView')),
  Section: dynamic(() => import('@eneco/sitecore-components-content/Section/Section')),
  SplitView: dynamic(() => import('@eneco/sitecore-components-content/SplitView/SplitView')),

  // Wrappable components
  ArticleCard: dynamic(() => import('@eneco/sitecore-components-content/ArticleCard/ArticleCard')),
  ArticleContentCard: dynamic(() => import('@eneco/sitecore-components-content/ArticleContentCard/ArticleContentCard')),
  ContentCard: dynamic(() => import('@eneco/sitecore-components-content/ContentCard/ContentCard')),
  ProductCard: dynamic(() => import('@eneco/sitecore-components-content/ProductCard/ProductCard')),
  StickyNav: dynamic(() => import('@eneco/sitecore-components-content/StickyNav/StickyNav')),
  Table: dynamic(() => import('@eneco/sitecore-components-content/Table/Table')),
  TitleTextCTA: dynamic(() => import('@eneco/sitecore-components-content/TitleTextCTA/TitleTextCTA')),
  PersonalizedTitleTextCTA: dynamic(
    () => import('@eneco/sitecore-components-content/PersonalizedTitleTextCTA/PersonalizedTitleTextCTA'),
  ),
  Checklist: dynamic(() => import('@eneco/sitecore-components-content/Checklist/Checklist')),
  USPItem: dynamic(() => import('@eneco/sitecore-components-content/USPItem/USPItem')),
  Video: dynamic(() => import('@eneco/sitecore-components-content/Video/Video')),

  // MeterReadings
  'meterreadings-flow': dynamic(() => import('@apps/meterreadings-nl-multilabel/MeterReadingsFlow')),
  RegistrationAccountCreate: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationFlow/RegistrationFlow'),
  ),
  RegistrationAccountReset: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationFlow/RegistrationFlow'),
  ),
  RegistrationFooter: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationFooter/RegistrationFooter'),
  ),
  RegistrationHeader: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationHeader/RegistrationHeader'),
  ),

  //Forms
  GenericForm: dynamic(() => import('@eneco/sitecore-components-forms/GenericForm/GenericForm')),
  GenericFormAddressField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormAddress/GenericFormAddressField'),
  ),
  GenericFormNameField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormNameField/GenericFormNameField'),
  ),
  GenericFormParagraph: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormParagraph/GenericFormParagraph'),
  ),
  GenericFormSalutationField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormSalutation/GenericFormSalutation'),
  ),
  GenericFormRadioGroup: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormRadioGroup/GenericFormRadioGroup'),
  ),
  GenericFormCheckboxField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormCheckboxField/GenericFormCheckboxField'
      ),
  ),
  GenericFormCheckboxGroup: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormCheckboxGroup/GenericFormCheckboxGroup'
      ),
  ),
  GenericFormDateField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormDateField/GenericFormDateField'),
  ),
  GenericFormEmailInputField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormEmailInputField/GenericFormEmailInputField'
      ),
  ),
  GenericFormNumberInputField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormNumberInputField/GenericFormNumberInputField'
      ),
  ),
  GenericFormPhoneNumberInputField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormPhoneNumberInputField/GenericFormPhoneNumberInputField'
      ),
  ),
  GenericFormTextAreaInputField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormTextAreaInputField/GenericFormTextAreaInputField'
      ),
  ),
  GenericFormInputSelect: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormInputSelect/GenericFormInputSelect'),
  ),
  GenericFormDivider: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormDivider/GenericFormDivider'),
  ),
  GenericFormInputField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormInputField/GenericFormInputField'),
  ),
  ContactForm: dynamic(() => import('@eneco/sitecore-components-forms/ContactForm/ContactForm')),
  DeceasedForm: dynamic(() => import('@eneco/sitecore-components-forms/DeceasedForm/DeceasedForm')),
};
